import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { PermissionLevelType } from "@/pages/configuracoes/schemas";

interface PermissionRowProps {
  title: string;
  value: PermissionLevelType;
  onChange: (value: PermissionLevelType) => void;
  name: string;
}

export function PermissionRow({ title, value, onChange, name }: PermissionRowProps) {
  return (
    <div className="flex flex-col gap-[14px] w-full">
      {/* Title */}
      <p className="font-['Plus_Jakarta_Sans'] font-bold text-[16px] text-white leading-normal">
        {title}
      </p>

      {/* Radio Group */}
      <RadioGroup
        value={value}
        onValueChange={(val) => onChange(val as PermissionLevelType)}
        className="flex items-center gap-[14px]"
      >
        {/* Acesso Total */}
        <div className="flex items-center gap-[14px]">
          <RadioGroupItem value="full_access" id={`${name}-full`} />
          <label
            htmlFor={`${name}-full`}
            className="font-['Plus_Jakarta_Sans'] font-normal text-[16px] text-white leading-normal cursor-pointer"
          >
            Acesso Total
          </label>
        </div>

        {/* Só Visualizar */}
        <div className="flex items-center gap-[14px]">
          <RadioGroupItem value="view_only" id={`${name}-view`} />
          <label
            htmlFor={`${name}-view`}
            className="font-['Plus_Jakarta_Sans'] font-normal text-[16px] text-white leading-normal cursor-pointer"
          >
            Só Visualizar
          </label>
        </div>

        {/* Sem acesso */}
        <div className="flex items-center gap-[14px]">
          <RadioGroupItem value="no_access" id={`${name}-none`} />
          <label
            htmlFor={`${name}-none`}
            className="font-['Plus_Jakarta_Sans'] font-normal text-[16px] text-white leading-normal cursor-pointer"
          >
            Sem acesso
          </label>
        </div>
      </RadioGroup>
    </div>
  );
}

PermissionRow.displayName = "PermissionRow";
